import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import SideNav from './components/layout/sidenav/SideNav';
import LoginPage from './components/login/LoginPage';
import './App.css';
import { useStyles } from './components/layout/sidenav/sideNavStyles';

const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#42ADE2',
      dark: '#42ADE2',
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#C6C6C6',
      main: '#6D6E70',
      // dark: will be calculated from palette.secondary.main,
      // contrastText: will be calculated to contrast with palette.secondary.main
    },
    // error: will use the default color
  },
  overrides: {
    MuiInput: {
      underline: 'green',
    },
  },
});

function App(props) {
  const classes = useStyles();
  return (
    <div className='App'>
      <BrowserRouter>
        <MuiThemeProvider theme={theme}>
          <div className={classes.root}>
            <Switch>
              <Route exact path='/' component={LoginPage} />
              {/* routes are inside sidenav */}
              <Route component={SideNav} />
            </Switch>
          </div>
        </MuiThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
